import React from 'react'
import "../css/SearchInput.css"
const SearchInput = ({search, placeholder = "search.."}) => {
  return <>
        <div className="input-wrapper">
  <button className="iconSearch">
  <svg
  className='ms-1'
  width="20px"
  height="20px"
  viewBox="0 0 24 24"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M11.5 21C16.7467 21 21 16.7467 21 11.5C21 6.25329 16.7467 2 11.5 2C6.25329 2 2 6.25329 2 11.5C2 16.7467 6.25329 21 11.5 21Z"
    stroke="#194479"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  ></path>
  <path
    d="M22 22L20 20"
    stroke="#194479"
    strokeWidth="3"
    strokeLinecap="round"
    strokeLinejoin="round"
  ></path>
</svg>

  </button>
  <input type="search" name="text" onChange={search} className="inputSearch" placeholder={placeholder} />
</div>
  </>
}

export default SearchInput
